import { useEffect, useState } from "react";
import { newsCategoryModel } from "../entity/newsCategories/NewsCategoryModel";
import { useNavigate, useParams } from "react-router-dom";
import { z } from 'zod';
import { updateNewsCategoryUseCase } from "../useCases/updateNewsCategoryUseCase";
import { getNewsCategoryUseCase } from "../useCases/getNewsCategoryUseCase";

const categorySchema = z.object({
    name: z.string().min(1, { message: "Not empty" }),
    description: z.string().nullable(),
    slug: z.string().min(1, { message: "Not empty" }),
    image: z.any().refine((file) => (file && file.size && file.size <= 1 * 1024 * 1024), { message: "File size should be less than or equal to 1 MB" }).nullable().optional(),
});

export const useNewsCategoryEditing = () => {
    const id = useParams().id;
    const [loading, setLoading] = useState(false);
    const [errors, setErrors] = useState({ name: '', description: '', slug: '', image: '' });
    const category = newsCategoryModel.newsCategory;
    const navigate = useNavigate();

    useEffect(() => {
        getNewsCategoryUseCase(Number(id));
        return () => { newsCategoryModel.newsCategory = null; }
    }, []);

    const onChange = (value: string, field: string) => {
        if (newsCategoryModel.newsCategory) {
            newsCategoryModel.newsCategory = { ...newsCategoryModel.newsCategory, [field]: value };
            setErrors((prev) => ({ ...prev, [field]: '' }));
        }
    }

    const onUpdateCategory = async () => {
        setLoading(true);
        const result: any = categorySchema.safeParse({ ...newsCategoryModel.newsCategory });
        if (result.success && newsCategoryModel.newsCategory) {
            const result = await updateNewsCategoryUseCase(newsCategoryModel.newsCategory as any);
            if (!result?.isError) {
                navigate(`/dashboard/news-categories`);
            }
        } else {
            result.error.errors.map((item: any) => {
                setErrors((prev) => ({ ...prev, [item.path[0]]: item.message }));
            })
        }
        setLoading(false);
    }

    return { category, errors, onChange, onUpdateCategory };

}